module.exports = __webpack_public_path__ + "assets/emberjs.05be7d6e.svg";